import { matchPath, useLocation } from "react-router";

import { ROUTES } from "~/constants/routing";
import { labelByTypeFilterEnum } from "~/feature/dashboard/components/sortAndFilters/TypeFilterDropdown/constants";
import { TypeFilterEnum } from "~/feature/dashboard/components/sortAndFilters/TypeFilterDropdown/types";
import { EventTagEnum, labelByEventTagEnum } from "~/types/tag";

export type CategoryTab = {
  key: string;
  label: string;
  to: string;
  isActive: boolean;
};

export const categoryTabsConfig = [
  {
    key: EventTagEnum.ALL,
    label: labelByEventTagEnum[EventTagEnum.ALL],
    path: ROUTES.main.path,
    to: ROUTES.main.createURL(),
  },
  {
    key: EventTagEnum.TRENDING,
    label: labelByEventTagEnum[EventTagEnum.TRENDING],
    path: ROUTES.trending.path,
    to: ROUTES.trending.createURL(),
  },
  {
    key: EventTagEnum.BREAKING,
    label: labelByEventTagEnum[EventTagEnum.BREAKING],
    path: ROUTES.breaking.path,
    to: ROUTES.breaking.createURL(),
  },
  {
    key: EventTagEnum.NEW,
    label: labelByEventTagEnum[EventTagEnum.NEW],
    path: ROUTES.new.path,
    to: ROUTES.new.createURL(),
  },
  {
    key: EventTagEnum.ENDING_SOON,
    label: labelByEventTagEnum[EventTagEnum.ENDING_SOON],
    path: ROUTES.endingSoon.path,
    to: ROUTES.endingSoon.createURL(),
  },
  {
    key: TypeFilterEnum.Binary,
    label: labelByTypeFilterEnum[TypeFilterEnum.Binary],
    path: ROUTES.binary.path,
    to: ROUTES.binary.createURL(),
  },
  {
    key: TypeFilterEnum.MultiOutcome,
    label: labelByTypeFilterEnum[TypeFilterEnum.MultiOutcome],
    path: ROUTES.multiOutcome.path,
    to: ROUTES.multiOutcome.createURL(),
  },
  {
    key: TypeFilterEnum.UMADisputed,
    label: labelByTypeFilterEnum[TypeFilterEnum.UMADisputed],
    path: ROUTES.umaDisputed.path,
    to: ROUTES.umaDisputed.createURL(),
  },
  {
    key: TypeFilterEnum.Aggregated,
    label: labelByTypeFilterEnum[TypeFilterEnum.Aggregated],
    path: ROUTES.aggregated.path,
    to: ROUTES.aggregated.createURL(),
  },
];

export const useCategoryTabs = (): CategoryTab[] => {
  const { pathname } = useLocation();

  return categoryTabsConfig.map(({ key, label, to, path }) => ({
    key,
    label,
    to,
    isActive: !!matchPath({ path, end: true }, pathname),
  }));
};
